export const getBooleanEnvValue = (envValue?: string) => envValue && JSON.parse(envValue);